module.exports = __webpack_public_path__ + "dingbeauty-build/img/no_reservation.ed502dc9.svg";